export enum BrandVoucherStatusEnum {
  Active = 1,
  Redeemed = 2,
  Rejected = 3,
  Expired = 4,
}

export interface BrandVoucher {
  id: string;
  name: string;
  amount: number;
  currencyCode: string;
  status: BrandVoucherStatusEnum;
  expiresAt: string | Date;
  expiredAt: string | Date | null;
  createdDate?: string | Date;
  redemptionCount?: number;
}

export interface BrandVoucherRedemption {
  id: string;
  businessAccountId: string;
  companyName: string;
  redeemedAt: string | Date;
}

export interface BrandVoucherDetail extends BrandVoucher {
  redemptions: BrandVoucherRedemption[];
  createdByFirebaseUid?: string;
  createdByName?: string;
}

export function brandVoucherStatusLabel(status: BrandVoucherStatusEnum): string {
  switch (status) {
    case BrandVoucherStatusEnum.Active:
      return 'Active';
    case BrandVoucherStatusEnum.Redeemed:
      return 'Redeemed';
    case BrandVoucherStatusEnum.Rejected:
      return 'Rejected';
    case BrandVoucherStatusEnum.Expired:
      return 'Expired';
    default:
      return `Status ${status}`;
  }
}

export interface CreateBrandVoucherRequest {
  name: string;
  amount: number;
  currencyCode: 'gbp' | 'usd' | 'eur';
  expiresAt?: string;
}

export interface RedeemBrandVoucherRequest {
  businessAccountId: string;
  name: string;
}

export interface ActiveBrandVouchersResponse {
  hasActive: boolean;
}
